// JS
import React, { useState, useEffect } from 'react';
import {
  ppHeadingOverridesOpen,
  getInternationalPriceNuqlium
} from '../shared/utils';

// COMPNENTS
import PaymentPopup from '../PaymentPopup';

// COMP
const KlarnaNew = ({
  data,
  currency,
  enableOverrides = true,
  disableOverrides
}) => {
  const [klarnaProdPrice, setKlarnaProdPrice] = useState(null);
  const [showHidePaymentPopup, setShowHidePaymentPopup] = useState(false);

  useEffect(() => {
    if (data.product.option.onsale) {
      setKlarnaProdPrice(
        (data.product.option.promotionpriceasnumber / 3).toFixed(2)
      );
    } else {
      setKlarnaProdPrice((data.product.option.priceasnumber / 3).toFixed(2));
    }
  }, [
    currency,
    data.product.option.onsale,
    data.product.option.priceasnumber,
    data.product.option.promotionpriceasnumber
  ]);

  return (
    <>
      {showHidePaymentPopup && (
        <PaymentPopup
          data={data}
          showHidePaymentPopup={showHidePaymentPopup}
          setShowHidePaymentPopup={setShowHidePaymentPopup}
          klarnaProdPrice={klarnaProdPrice}
          disableOverrides={disableOverrides}
        />
      )}
      {data && data.product.option && (
        <div className="klarna-widget">
          <span className="klarna-logo-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69 34.5">
              <rect
                width={69}
                height={34.5}
                rx={4.182}
                ry={4.182}
                fill="#f5f5f5"
              />
              <path
                d="M53.739 19.461a1.167 1.167 0 1 0-.007 2.333 1.167 1.167 0 0 0 .007-2.333Zm-3.822-.905a1.68 1.68 0 1 0-1.753 1.602l.08.002c.904.018 1.652-.7 1.673-1.604Zm.006-3.12h1.85v6.238h-1.85v-.398a3.23 3.23 0 0 1-1.835.571 3.291 3.291 0 0 1 0-6.581 3.217 3.217 0 0 1 1.835.571v-.4Zm-14.81.812v-.811h-1.896v6.237h1.9v-2.913c0-.983 1.055-1.511 1.787-1.511h.022v-1.814a2.3 2.3 0 0 0-1.812.811Zm-4.719 2.307a1.68 1.68 0 1 0-1.753 1.602l.08.002c.904.018 1.652-.7 1.673-1.604Zm.006-3.12h1.851v6.238H30.4v-.398a3.23 3.23 0 0 1-1.835.571 3.291 3.291 0 0 1 0-6.581 3.217 3.217 0 0 1 1.835.571v-.4Zm11.138-.167a2.243 2.243 0 0 0-1.907.87v-.702h-1.842v6.237h1.865v-3.279a1.31 1.31 0 0 1 1.389-1.414c.812 0 1.282.49 1.282 1.4v3.29h1.847v-3.964a2.455 2.455 0 0 0-2.634-2.439Zm-18.93 6.404h1.937v-9.017h-1.937v9.018Zm-8.51 0h2.051v-9.017h-2.05v9.018Zm7.175-9.018a7.206 7.206 0 0 1-2.098 5.123l2.835 3.901h-2.534l-3.08-4.241.796-.601a5.195 5.195 0 0 0 2.072-4.182h2.009Z"
                fill="#0a0b09"
              />
            </svg>
          </span>

          {data.product.option.priceasnumber >= 1000 ? (
            <span className="klarna-content-wrapper">
              Pay in 30 days. No fees.
            </span>
          ) : (
            <span className="klarna-content-wrapper">
              Make 3 payments of{' '}
              {getInternationalPriceNuqlium() === 'retail_eur' ? (
                <span className="klarna-price">&euro;{klarnaProdPrice}</span>
              ) : (
                <span className="klarna-price">&pound;{klarnaProdPrice}</span>
              )}
              .
            </span>
          )}
          <button
            className="klarna-more-info"
            onClick={(e) => {
              e.preventDefault();
              setShowHidePaymentPopup(true);
              window.scrollLock();
              enableOverrides && ppHeadingOverridesOpen();
            }}
          >
            Learn more
          </button>
        </div>
      )}
    </>
  );
};

export default KlarnaNew;
